module.exports = __webpack_public_path__ + "img/icon_list_fabulous.539b4ae7.svg";